import { Lock } from 'lucide-react';
import { ROUTES } from '@/lib/constants/routes';
import { UI_STRINGS } from '@/lib/constants/ui-strings';
import { LinkStatusCard } from '@/components/common/LinkStatusCard';

/**
 * "A work email is required" - `ProtectedRoute`'s `requiresWorkEmail` gate
 * (MYN-46 Create Startup flow). Composes the shared `LinkStatusCard` (same
 * card/icon/heading/body/CTA shape as the invite- and shared-profile-expired
 * screens) rather than the generic `AccessDenied`, per design review. The
 * CTA sends the user to their own account page to fix the email on file,
 * instead of logging them out - the `/me` Email card holds the one-time
 * Update Email action (the old `/me/edit` page was removed by MYN-217).
 */
export function WorkEmailRequiredState() {
  const S = UI_STRINGS.WORK_EMAIL_GATE;
  return (
    <LinkStatusCard
      icon={<Lock size={32} />}
      heading={S.TITLE}
      body={S.DESCRIPTION}
      ctaLabel={S.ACTION}
      ctaTo={ROUTES.ACCOUNT}
      fullScreen
    />
  );
}
